module.exports = __webpack_public_path__ + "img/newletter-30.aa61741.png";